import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const roumingService = {
  UsersSyncToAoDataGet,
  UsersSyncToAoStatusGet,
  UsersSyncToAoInfoGet,
  UsersSyncToAoTransferDataGet,
  UsersLoginToAoTransferDataGet,
  MainSystemSendRegDataGet,
  MainSystemSendRegDataAdd,
  MainSystemSendRegDataProcessed,
  AOSystemUrl
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

async function UsersSyncToAoDataGet() {
  return axios.get(model.baseUrl + 'Rouming/UsersSyncToAoDataGet').then(extract);
}

async function UsersSyncToAoStatusGet() {
  return axios.get(model.baseUrl + 'Rouming/UsersSyncToAoDataGet').then(extract);
}

async function UsersSyncToAoInfoGet() {
  return axios.get(model.baseUrl + 'Rouming/UsersSyncToAoInfoGet').then(extract);
}

async function UsersSyncToAoTransferDataGet() {
  return axios.get(model.baseUrl + 'Rouming/UsersSyncToAoTransferDataGet').then(extract);
}

async function UsersLoginToAoTransferDataGet() {
  return axios.get(model.baseUrl + 'Rouming/UsersLoginToAoTransferDataGet').then(extract);
}

async function MainSystemSendRegDataGet(id) {
  return axios.get(model.baseUrl + `Rouming/MainSystemSendRegDataGet?id=${id}`).then(extract);
}

async function AOSystemUrl(Id, googleReCaptchaResponse) {
  return axios
    .post(model.baseUrl + 'Rouming/AOSystemUrl', {
      Id, googleReCaptchaResponse
    })
    .then(extract);
}
async function MainSystemSendRegDataAdd(pData) {
  return axios
    .put(model.baseUrl + 'Rouming/MainSystemSendRegDataAdd', {
      pData: pData
    })
    .then(extract);
}

async function MainSystemSendRegDataProcessed(pMainSystemSendRegDataGuid) {
  return axios
    .put(model.baseUrl + 'Rouming/MainSystemSendRegDataProcessed', {
      pMainSystemSendRegDataGuid: pMainSystemSendRegDataGuid
    })
    .then(extract);
}
